import CryptoJS from 'crypto-js';
import {config} from '../constants/Constants';

var bytes = require('utf8-bytes');

class CalculateHash{

  ///---Calculate hash by concating all parameters--///

    ah(obj){
        let data = '';        
        Object.keys(obj).map(v => data += obj[v])     
        var _hMacKey = null;
        var _normKey = null;
        const BIG_PRIME_NUMBER = 2147483647;
        var iKeyLength = 64;
            if (_hMacKey == null)
            {
                _hMacKey = config.url._hMacKey;
            }
            if (_normKey == null)
            {                
                var keyBytes = bytes(_hMacKey);                      
                _normKey = [];
                var iSum = 0;
                
                for (let i = 0; i < iKeyLength; i++)
                {
                    if (i < keyBytes.length)
                    {
                        iSum = iSum + keyBytes[i];                 
                    }
                    else
                    {
                        iSum = iSum + i;
                        
                    }
                _normKey[i] = (iSum * BIG_PRIME_NUMBER) % (255 + 1);
                }
            }
            var inputBytes = bytes(data);
            var normKeyWA = CryptoJS.lib.WordArray.create(new Uint8Array(_normKey));        // Convert into WordArray via typed array
            var inputBytesWA = CryptoJS.lib.WordArray.create(new Uint8Array(inputBytes));
            var hash = CryptoJS.HmacSHA256(
                inputBytesWA,
                normKeyWA
            );            
            var last8Bytes = CryptoJS.lib.WordArray.create(hash.words.slice((32 - 8) / 4));
            var last8BytesHex = last8Bytes.toString(CryptoJS.enc.Hex).toUpperCase();        // Convert into hex encoded string using CryptoJS's Hex encoder            
            return (last8BytesHex)            
    }
}
const calculateHash = new CalculateHash();
export default calculateHash;